export default {
  props: {
    disabled: Boolean,
    value: [ Array, File ],
    classField: String,
    uploadFileRef: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'Procurar arquivos'
    },
    placeholder: {
      type: String,
      default: 'Nenhum arquivo selecionado'
    },
    multiple: Boolean,
    size: {
      type: String,
      default: ''
    },
    accept: String
  },
  data: () => {
    return {
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },
    bformFileClick: function () {
      this.$refs[this.uploadFileRef].$el.childNodes[0].click()
    }
  }
}
